<template lang="pug">
  .wrap
    page-title Edit Alert

    future-schedule-alert(v-if='alert && alert.status === "published"' :start-datetime='alert.startDatetime' name='alert')
    alert-form(v-if='alert' v-model='alert' :create='false' @save='onSave' @delete='confirmDelete')

</template>

<script>
import _ from "lodash";

import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import AlertForm from "@/brapp/components/shared/alerts/AlertForm";
import CrudMixin from "@/shared/mixins/Crud";
import FutureScheduleAlert from "@/shared/components/FutureScheduleAlert";

export default {
  components: { PageTitle, AlertForm, FutureScheduleAlert },
  mixins: [CrudMixin],
  data() {
    return {
      alert: null
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("alerts", ["fetchAlert", "updateAlert", "deleteAlert"]),
    loadData() {
      this.loading = true;
      const loader = this.$loading({ target: "#main-content" });

      this.fetchAlert({ id: this.$route.params.alertId }).then(data => {
        this.alert = {
          ...data,
          assigneeAppLicenseGroupIds: [],
          assigneeUserIds: [],
          assignees: data.assignees.map(a => ({
            ...a,
            appLicenseGroup: _.get(a, "appLicenseGroup.id")
          }))
        };
        this.loading = false;
        loader.close();
      });
    },
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const alertData = {
        ...this.alert,
        assigneeUserIds: this.alert.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.alert.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.loading = true;
      const loader = this.$loading({ target: "#main-content" });

      this.updateAlert({ data: alertData })
        .then(data => {
          this.alert = {
            ...data,
            assignees: data.assignees.map(a => ({
              ...a,
              appLicenseGroup: _.get(a, "appLicenseGroup.id")
            }))
          };
          loader.close();
          this.$notify({
            title: "Success",
            message: "Alert successfully saved",
            type: "success"
          });
        })
        .catch(() => {
          loader.close();
          this.$notify({
            title: "Error",
            message: "Oops, something went wrong",
            type: "error"
          });
        });
    },
    confirmDelete() {
      this.$confirm(
        "This will permanently delete this alert. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteAlert({ id: this.alert.id }).then(() => {
            this.$message({
              type: "info",
              message: "Alert deleted"
            });
            this.$router.push({ name: "alertList" });
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss"></style>
